import React from "react";
import { docsColors } from "@/lib/docs-theme";

export interface Parameter {
  name: string;
  type: string;
  required: boolean;
  description: string;
  default?: string;
  example?: string;
}

interface ParameterTableProps {
  parameters: Parameter[];
  title?: string;
}

export default function ParameterTable({ parameters, title = "Parameters" }: ParameterTableProps) {
  if (parameters.length === 0) {
    return null;
  }

  return (
    <div className="my-6">
      <h3 className={`text-lg font-semibold ${docsColors.text.heading} mb-3`}>{title}</h3>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className={`border-b ${docsColors.border.default}`}>
              <th className={`text-left px-4 py-2 font-medium ${docsColors.text.heading}`}>Name</th>
              <th className={`text-left px-4 py-2 font-medium ${docsColors.text.heading}`}>Type</th>
              <th className={`text-left px-4 py-2 font-medium ${docsColors.text.heading}`}>
                Required
              </th>
              <th className={`text-left px-4 py-2 font-medium ${docsColors.text.heading}`}>
                Description
              </th>
            </tr>
          </thead>
          <tbody>
            {parameters.map((param, index) => (
              <tr
                key={param.name}
                className={`border-b ${docsColors.border.muted} ${
                  index % 2 === 0 ? "" : docsColors.bg.card
                }`}
              >
                <td className={`px-4 py-3 font-mono text-sm ${docsColors.text.body}`}>
                  {param.name}
                </td>
                <td className={`px-4 py-3 text-sm ${docsColors.text.body}`}>
                  <code
                    className={`px-1 py-0.5 rounded ${docsColors.bg.code} ${docsColors.text.onDark} text-xs`}
                  >
                    {param.type}
                  </code>
                </td>
                <td className={`px-4 py-3 text-sm`}>
                  {param.required ? (
                    <span className={docsColors.icon.error}>Yes</span>
                  ) : (
                    <span className={docsColors.text.muted}>No</span>
                  )}
                </td>
                <td className={`px-4 py-3 text-sm ${docsColors.text.body}`}>
                  {param.description}
                  {param.default && (
                    <span className={`block mt-1 ${docsColors.text.muted}`}>
                      Default: <code className="font-mono">{param.default}</code>
                    </span>
                  )}
                  {param.example && (
                    <span className={`block mt-1 ${docsColors.text.muted}`}>
                      Example: <code className="font-mono">{param.example}</code>
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
